import React from "react";
import { Box } from "@mui/material";
import { Palette as PaletteIcon } from "@mui/icons-material";
import useAuth from "../../hooks/useAuth";
import { useClinicTheme } from "../../theme";
import { COLORS } from "../../styles/uiConstants";
import { PageHeaderBar } from "../../components/molecules";
import AppearanceTab from "../Clinics/ClinicDetail/AppearanceTab";

export default function PanelAppearance() {
  const { auth } = useAuth();
  const token = auth?.accessToken;
  const { palette } = useClinicTheme();
  const clinicId = auth?.clinic?._id || auth?.user?.clinic?._id || auth?.clinic || null;

  return (
    <Box sx={{ height: "100%", display: "flex", flexDirection: "column", overflow: "hidden", bgcolor: COLORS.slate50 }}>
      <PageHeaderBar
        icon={<PaletteIcon sx={{ fontSize: 24 }} />}
        title="Görünüm"
        subtitle="Panel tema rengi ve logo ayarları"
      />

      <Box sx={{ flex: 1, overflow: "auto", minHeight: 0 }}>
        <AppearanceTab apiMode="clinic" clinicId={clinicId} token={token} palette={palette} />
      </Box>
    </Box>
  );
}
